import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import _ from 'lodash';
import ExportCSVRow from './ExportCSVRow';
import { BtnOutlineGreen } from '../../styled-components';
import { getValidationErrorMessage } from './helpers';

function ContractsImportPaidsFeedbackModal({ toggle, isOpen, data = {} }) {
  const [t] = useTranslation('CONTRACTS');

  const {
    errors = {},
    unpaidCount = 0,
    paidCount = 0,
    validationErrors: topValidationErrors,
  } = data;
  let validationErrors = false;
  if (topValidationErrors && Array.isArray(topValidationErrors.message)) {
    validationErrors = topValidationErrors.message;
  }
  if (
    topValidationErrors &&
    topValidationErrors.message &&
    !Array.isArray(topValidationErrors.message)
  ) {
    validationErrors = [topValidationErrors.message];
  }

  const {
    contractMalformed = [],
    alreadyInvoiced = [],
    alreadyUnpaid = [],
  } = errors;

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {validationErrors
          ? t('MALFORMED_FILE')
          : t('IMPORTED_CONTRACTS_PAID_FEEDBACK')}
      </ModalHeader>

      {!validationErrors && (
        <ModalBody>
          <Row>
            <Col sm="12">
              <h5>
                {t('CONTRACTS_SET_UNPAID_NUMBER')} {unpaidCount || 0}
              </h5>
              <h5>
                {t('CONTRACTS_SET_PAID_NUMBER')} {paidCount || 0}
              </h5>
            </Col>
          </Row>
          <Row>
            <Col sm="12">
              <h5>
                {t('NOT_INSERTED_PAID_CONTRACTS_NUMBER')}:{' '}
                {_.uniqWith(
                  [...contractMalformed, ...alreadyInvoiced, ...alreadyUnpaid],
                  _.isEqual
                ).length || 0}
              </h5>
              <ul>
                <ExportCSVRow
                  data={contractMalformed}
                  text={t('MALFORMED_CONTRACTS')}
                />

                <ExportCSVRow
                  data={alreadyInvoiced}
                  text={t('ALREADY_INVOICED_CONTRACTS')}
                />

                <ExportCSVRow
                  data={alreadyUnpaid}
                  text={t('ALREADY_UNPAID_CONTRACTS')}
                />
              </ul>
            </Col>
          </Row>
        </ModalBody>
      )}
      {validationErrors && (
        <ModalBody>
          <Row>
            <Col sm="12">
              {validationErrors.map((v) => (
                <h5>{getValidationErrorMessage({ message: v })}</h5>
              ))}
            </Col>
          </Row>
        </ModalBody>
      )}
      <ModalFooter>
        <BtnOutlineGreen type="button" className="uppercase" onClick={toggle}>
          {t('COMMON:CLOSE')}
        </BtnOutlineGreen>
      </ModalFooter>
    </Modal>
  );
}

export default ContractsImportPaidsFeedbackModal;
